module.exports = __webpack_public_path__ + "static/sword-of-descension-146b77b012321070a7267fbe67e1718d.png";